/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "planner";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface MovementCommandSource {
}

export enum MovementCommandSource_Enum {
  UNKNOWN = 0,
  PHONE = 1,
  WAYPOINT = 2,
  SKILL = 3,
  JOYSTICK = 4,
  BEACON = 5,
  DOCK = 6,
  GPS_INITIALIZATION = 7,
  EXTERNAL_API = 9,
  TRAJECTORY_ACTION_PLANNER = 10,
  UNRECOGNIZED = -1,
}

export function movementCommandSource_EnumFromJSON(object: any): MovementCommandSource_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return MovementCommandSource_Enum.UNKNOWN;
    case 1:
    case "PHONE":
      return MovementCommandSource_Enum.PHONE;
    case 2:
    case "WAYPOINT":
      return MovementCommandSource_Enum.WAYPOINT;
    case 3:
    case "SKILL":
      return MovementCommandSource_Enum.SKILL;
    case 4:
    case "JOYSTICK":
      return MovementCommandSource_Enum.JOYSTICK;
    case 5:
    case "BEACON":
      return MovementCommandSource_Enum.BEACON;
    case 6:
    case "DOCK":
      return MovementCommandSource_Enum.DOCK;
    case 7:
    case "GPS_INITIALIZATION":
      return MovementCommandSource_Enum.GPS_INITIALIZATION;
    case 9:
    case "EXTERNAL_API":
      return MovementCommandSource_Enum.EXTERNAL_API;
    case 10:
    case "TRAJECTORY_ACTION_PLANNER":
      return MovementCommandSource_Enum.TRAJECTORY_ACTION_PLANNER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MovementCommandSource_Enum.UNRECOGNIZED;
  }
}

export function movementCommandSource_EnumToJSON(object: MovementCommandSource_Enum): string {
  switch (object) {
    case MovementCommandSource_Enum.UNKNOWN:
      return "UNKNOWN";
    case MovementCommandSource_Enum.PHONE:
      return "PHONE";
    case MovementCommandSource_Enum.WAYPOINT:
      return "WAYPOINT";
    case MovementCommandSource_Enum.SKILL:
      return "SKILL";
    case MovementCommandSource_Enum.JOYSTICK:
      return "JOYSTICK";
    case MovementCommandSource_Enum.BEACON:
      return "BEACON";
    case MovementCommandSource_Enum.DOCK:
      return "DOCK";
    case MovementCommandSource_Enum.GPS_INITIALIZATION:
      return "GPS_INITIALIZATION";
    case MovementCommandSource_Enum.EXTERNAL_API:
      return "EXTERNAL_API";
    case MovementCommandSource_Enum.TRAJECTORY_ACTION_PLANNER:
      return "TRAJECTORY_ACTION_PLANNER";
    case MovementCommandSource_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseMovementCommandSource(): MovementCommandSource {
  return {};
}

export const MovementCommandSource = {
  encode(_: MovementCommandSource, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MovementCommandSource {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMovementCommandSource();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MovementCommandSource {
    return {};
  },

  toJSON(_: MovementCommandSource): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MovementCommandSource>, I>>(base?: I): MovementCommandSource {
    return MovementCommandSource.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MovementCommandSource>, I>>(_: I): MovementCommandSource {
    const message = createBaseMovementCommandSource();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
